<template>
  <Tooltip
    v-if="props.tooltipText"
    :text="props.tooltipText"
    class="information-tooltip"
    :data-test="`${props.name}-tooltip`"
  >
    <img
      src="../assets/information-icon.svg"
      alt="information"
      :data-test="`${props.name}-tooltip-icon`"
      :width="iconWidth"
      tabindex="0"
    />
  </Tooltip>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { Tooltip } from "uiv";

const props = defineProps<{ tooltipText: string; name: string; iconWidth: string }>();

const iconWidth = computed(() => {
  return props.iconWidth || "16";
});
</script>

<style scoped lang="less"></style>
